import { Calendar, Phone, MapPin, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

const FinalCTASection = ({ openBookingModal }) => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-zinc-900 relative overflow-hidden" data-testid="final-cta-section">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
        {/* Heading */}
        <h2 
          className="text-3xl md:text-4xl lg:text-5xl text-white mb-4"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {language === "fr" 
            ? "Prête à vous sentir plus" 
            : "Ready to Feel More"}{" "}
          <span className="italic text-amber-400">
            {language === "fr" ? "confiante?" : "Confident?"}
          </span>
        </h2>

        <p className="text-zinc-400 text-lg mb-10 max-w-2xl mx-auto">
          {language === "fr"
            ? "Faites le premier pas vers une version rafraîchie de vous-même. Réservez votre consultation gratuite aujourd'hui."
            : "Take the first step toward a refreshed, confident you. Book your free consultation today."}
        </p>

        {/* Main CTA Button */}
        <Button
          onClick={openBookingModal}
          className="bg-amber-500 hover:bg-amber-400 text-black text-lg px-10 py-7 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 mb-10"
          style={{ fontFamily: "'Playfair Display', serif" }}
          data-testid="final-cta-book-btn"
        >
          <Calendar className="w-5 h-5 mr-2" />
          {language === "fr" ? "RÉSERVER VOTRE CONSULTATION" : "BOOK YOUR CONSULTATION"}
        </Button>

        {/* Contact Options */}
        <div className="flex flex-wrap items-center justify-center gap-8 text-zinc-400">
          <a 
            href="sms:+16138500805?body=Hi, I'd like to book an appointment"
            className="flex items-center gap-2 hover:text-amber-400 transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            <span>(613) 850-0805</span>
          </a>
          
          <div className="hidden sm:block w-px h-5 bg-zinc-700" />
          
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-amber-400" />
            <span>Ottawa • Kanata • Carleton Place</span>
          </div>
        </div>

        {/* Urgency/Trust Text */}
        <p className="mt-8 text-zinc-500 text-sm">
          {language === "fr"
            ? "✓ Consultation gratuite • ✓ Financement disponible • ✓ Résultats naturels garantis"
            : "✓ Free consultation • ✓ Financing available • ✓ Natural results guaranteed"}
        </p>
      </div>
    </section>
  );
};

export default FinalCTASection;
